module.exports = {
  renderer: [ 'type', require(3) ],
  pathMap: [ 'type', require(4) ]
};